import { useContext, useState, useMemo } from "react";
import { Modal } from "react-bootstrap";
import styles from "./index.module.scss";
import { Button } from "react-bootstrap";
import { SettingsContext } from "../../providers/SettingsProvider";
import Select from "react-select";
import { useNavigate } from "react-router-dom";
import { getTeamDropdownItems } from "../../constants";

const ratingTypes = [
  {
    value: "common",
    label: "Загальний",
  },
  {
    value: "round",
    label: "Тур",
  },
  {
    value: "month",
    label: "Місяць",
  },
  {
    value: "club",
    label: "Клубний",
  },
];

const monthsList = [
  {
    value: "Aug",
    label: "Серпень",
  },
  {
    value: "Sep",
    label: "Вересень",
  },
  {
    value: "Oct",
    label: "Жовтень",
  },
  {
    value: "Nov",
    label: "Листопад",
  },
  {
    value: "Dec",
    label: "Грудень",
  },
  {
    value: "Mar",
    label: "Березень",
  },
  {
    value: "Apr",
    label: "Квітень",
  },
  {
    label: "Травень",
    value: "May",
  },
];

const ArchivedStandingsSearch = ({ show, onHide, season, setSearchReset }) => {
  const navigate = useNavigate();

  const { teams, lastRound, archivedSeasons } = useContext(SettingsContext);

  const seasonsList = useMemo(
    () =>
      archivedSeasons.map((season) => ({
        value: +season,
        label: `${+season}/${+season + 1}`,
      })),
    [archivedSeasons]
  );

  const [selectedSeason, setSelectedSeason] = useState(null);
  const [selectedRating, setSelectedRating] = useState(null);
  const [selectedRound, setSelectedRound] = useState(null);
  const [selectedMonth, setSelectedMonth] = useState(null);
  const [selectedTeam, setSelectedTeam] = useState(null);

  const teamsOptions = useMemo(() => getTeamDropdownItems(teams), [teams]);

  const roundsList = useMemo(
    () =>
      [...Array(lastRound).keys()]
        .map((x) => ++x)
        .map((round) => ({ label: round, value: round })),
    [lastRound]
  );

  const onSeasonChange = (selectedOption) => {
    const targetOption = seasonsList.find(
      (season) => season.value === selectedOption.value
    );
    setSelectedSeason(targetOption);
  };

  const onRatingChange = (selectedOption) => {
    const targetOption = ratingTypes.find(
      (rating) => rating.value === selectedOption.value
    );
    setSelectedRating(targetOption);
    setSelectedRound(null);
    setSelectedMonth(null);
    setSelectedTeam(null);
  };

  const onRoundChange = (selectedOption) => {
    const targetOption = roundsList.find(
      (round) => round.value === selectedOption.value
    );
    setSelectedRound(targetOption);
    setSelectedMonth(null);
    setSelectedTeam(null);
  };

  const onMonthChange = (selectedOption) => {
    const targetOption = monthsList.find(
      (month) => month.value === selectedOption.value
    );
    setSelectedRound(null);
    setSelectedMonth(targetOption);
    setSelectedTeam(null);
  };

  const onTeamChange = (selectedOption) => {
    const targetOption = teamsOptions.find(
      (team) => team.value === selectedOption.value
    );
    setSelectedRound(null);
    setSelectedMonth(null);
    setSelectedTeam(targetOption);
  };

  const showRating = () => {
    onHide();
    const season = selectedSeason.value;
    const ratingId = selectedMonth?.value ?? selectedRound?.value ?? -1;

    setSearchReset(+new Date());

    if (selectedTeam?.value) {
      navigate(`/archived/${season}?clubId=${selectedTeam.value}`);
    } else {
      navigate(`/archived/${season}/${ratingId}`);
    }
  };

  const isRoundsRatingSelected = selectedRating?.value === "round";
  const isMonthsRatingSelected = selectedRating?.value === "month";
  const isClubsRaitingSelected = selectedRating?.value === "club";

  return (
    <Modal show={show} size="md" backdrop="static" onHide={onHide}>
      <Modal.Header closeButton>
        <Modal.Title className="flex">
          <i className="bi bi-search"></i>&nbsp;Пошук архівних рейтингів
        </Modal.Title>
      </Modal.Header>

      <Modal.Body>
        <>
          <p>
            Сезон
            <Select
              placeholder="Оберіть сезон"
              className={styles.dropdown}
              value={selectedSeason}
              options={seasonsList}
              onChange={onSeasonChange}
            />
          </p>
          <p>
            Тип рейтинга
            <Select
              placeholder="Оберіть рейтинг"
              className={styles.dropdown}
              value={selectedRating}
              options={ratingTypes}
              onChange={onRatingChange}
            />
          </p>

          {isRoundsRatingSelected && (
            <p>
              Тур
              <Select
                placeholder="Оберіть тур"
                className={styles.dropdown}
                value={selectedRound}
                options={roundsList}
                onChange={onRoundChange}
              />
            </p>
          )}

          {isMonthsRatingSelected && (
            <p>
              Тур
              <Select
                placeholder="Оберіть місяць"
                className={styles.dropdown}
                value={selectedMonth}
                options={monthsList}
                onChange={onMonthChange}
              />
            </p>
          )}

          {isClubsRaitingSelected && (
            <p>
              Клубна ліга
              <Select
                className={styles.dropdown}
                value={selectedTeam}
                options={teamsOptions}
                onChange={onTeamChange}
              />{" "}
            </p>
          )}
        </>

        <div className={styles.actions}>
          <Button
            disabled={
              selectedRating === null ||
              selectedSeason === null ||
              (isRoundsRatingSelected && !selectedRound?.value) ||
              (isMonthsRatingSelected && !selectedMonth?.value) ||
              (isClubsRaitingSelected && !selectedTeam?.value)
            }
            onClick={showRating}
            className={styles.btn}
          >
            <i className="bi bi-clipboard"></i>&nbsp;Показати
          </Button>
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default ArchivedStandingsSearch;
